module.exports = __webpack_public_path__ + "static/media/usg-currency-logo-horizontal.dbd2320f.png";